import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { CATEGORIES } from '../data/products';
const SOCIAL = [{
  label: 'Instagram',
  icon: InstagramIcon,
  href: 'https://www.instagram.com/zadar.uy'
}, {
  label: 'WhatsApp',
  icon: MessageCircleIcon,
  href: 'https://wa.me/59899123456'
}];
const NAV_LINKS = [{
  label: 'Inicio',
  to: '/'
}, {
  label: 'Productos',
  to: '/productos'
}, {
  label: 'Nosotros',
  to: '/#nosotros'
}, {
  label: 'Contacto',
  to: '/#contacto'
}];
export function Footer() {
  return <footer id="contacto" className="w-full border-t border-white/10 bg-black" data-id="element-597" data-mp="3qdf2v2jeis8j">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 py-14 sm:grid-cols-2 lg:grid-cols-5 lg:px-8 lg:py-20" data-id="element-598" data-mp="3qfjhofiu9bnl">
        <div className="sm:col-span-2 lg:col-span-1" data-id="element-599" data-mp="2eya0jzn6mvpg">
          <Logo size="md" data-id="element-600" data-mp="2ezuvhqdesgnu" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/50" data-id="element-601" data-mp="2evx98vvjb8zq">
            Accesorios fitness diseñados en Uruguay para entrenar fuerte sin
            dolor, sin lesiones y sin incomodidad.
          </p>
          <div className="mt-6 flex gap-2" data-id="element-602" data-mp="3v7gfq1b2ac9t">
            {SOCIAL.map(({
            label,
            icon: Icon,
            href
          }) => <a key={label} href={href} target="_blank" rel="noreferrer noopener" aria-label={`${label} (se abre en una pestaña nueva)`} className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 transition-colors hover:border-pink-500 hover:bg-pink-500 hover:text-white" data-id="element-603" data-mp="3q83svgk6x578">
                <Icon className="h-4 w-4" data-id="element-604" data-mp="ctgznbiec6r2" />
              </a>)}
          </div>
        </div>

        <nav aria-label="Navegación del sitio" data-id="element-605" data-mp="qujk5jtqt8zv">
          <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white" data-id="element-606" data-mp="qr5gm89cetqu">
            Navegación
          </h2>
          <ul className="mt-5 space-y-3" data-id="element-607" data-mp="tvcw1hybznae">
            {NAV_LINKS.map(link => <li key={link.label} data-id="element-608" data-mp="yu7hkrnonpy7">
                <Link to={link.to} className="text-sm text-white/50 transition-colors hover:text-pink-400" data-id="element-609" data-mp="yv953vlvy4wt">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Categorías" data-id="element-610" data-mp="1clumffvoy6sl">
          <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white" data-id="element-611" data-mp="1ckt4crg9ck1d">
            Tienda
          </h2>
          <ul className="mt-5 space-y-3" data-id="element-612" data-mp="1hiun1b9ruhcb">
            {CATEGORIES.map(cat => <li key={cat.id} data-id="element-613" data-mp="1mkbhop1nx7kg">
                <Link to={`/productos?cat=${cat.id}`} className="text-sm text-white/50 transition-colors hover:text-pink-400" data-id="element-614" data-mp="1mhxn0haw9xdf">
                  {cat.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Ayuda" data-id="element-615" data-mp="3tc2vszgywvg4">
          <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white" data-id="element-616" data-mp="2afncncg8i20a">
            Ayuda
          </h2>
          <ul className="mt-5 space-y-3" data-id="element-617" data-mp="25nc97zmaby2z">
            {['Envíos y devoluciones', 'Guía de tallas', 'Preguntas frecuentes', 'Términos y condiciones'].map(item => <li key={item} data-id="element-618" data-mp="1wlmas9tzjyvp">
                <a href="#" className="text-sm text-white/50 transition-colors hover:text-pink-400" data-id="element-619" data-mp="2tdpwzdxu7arr">
                  {item}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-620" data-mp="2kbgn8qae7lff">
          <h2 className="font-display text-lg uppercase tracking-[0.2em] text-white" data-id="element-621" data-mp="2kf4grpfu87u5">
            Contacto
          </h2>
          <ul className="mt-5 space-y-4 text-sm text-white/50" data-id="element-622" data-mp="18xutertl8vnk">
            <li className="flex items-start gap-3" data-id="element-623" data-mp="18w1phkad0pj9">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-pink-500" data-id="element-624" data-mp="13yrza2f5c9ud" />
              <span data-id="element-625" data-mp="2rvzkn7zbpvr2">Bvar. Artigas 1234, Montevideo, Uruguay</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-626" data-mp="2wmfyuuayxleh">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-pink-500" data-id="element-627" data-mp="2wn97y1xegmzs" />
              <a href="tel:+59899123456" className="hover:text-white" data-id="element-628" data-mp="2ivuef15v93eh">
                +598 99 123 456
              </a>
            </li>
            <li className="flex items-start gap-3" data-id="element-629" data-mp="2nue153saaj7w">
              <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-pink-500" data-id="element-630" data-mp="3bj72jfrodj9w" />
              <a href="mailto:hola@zadar.uy" className="hover:text-white" data-id="element-631" data-mp="3flbrw2b3btqq">
                hola@zadar.uy
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-632" data-mp="31nn70uh0wmlo">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-5 py-6 text-xs text-white/35 sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-633" data-mp="36jufov0t0c7b">
          <p data-id="element-634" data-mp="1q8qg1f1a3nbo">© {new Date().getFullYear()} ZADAR. Todos los derechos reservados.</p>
          <div className="flex items-center gap-5" data-id="element-635" data-mp="1v6s0o4ecrup9">
            <Link to="/mis-pedidos" className="transition-colors hover:text-white" data-id="element-636" data-mp="1nlfxrh5hjkqq">
              Mis pedidos
            </Link>
            <Link to="/login" className="transition-colors hover:text-white" data-id="element-637" data-mp="1im35uhzrbnha">
              Ingresar
            </Link>
            <Link to="/admin" className="transition-colors hover:text-white" data-id="element-638" data-mp="1wkjl4xboqmb1">
              Panel admin
            </Link>
            <span className="uppercase tracking-[0.2em]" data-id="element-639" data-mp="13xyjn41hwttr">Hecho en Uruguay</span>
          </div>
        </div>
      </div>
    </footer>;
}